module.exports = __webpack_public_path__ + "resources/img/img_edb_1_jp.9882898954cd1cf87238ec68746289c3.png";